import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { BMIHistoryItem } from '../../bmi-const/bmi-details-models';

@Component({
  selector: 'patient-bmi-history-list',
  standalone: true,
  imports: [CommonModule, DialogModule],
  templateUrl: './bmi-history-list.component.html',
  styleUrl: './bmi-history-list.component.css'
})
export class BmiHistoryListComponent {
  @Input() history: BMIHistoryItem[] = [];

  displayModal: boolean = false;
  selectedBmi: BMIHistoryItem | null = null;
  previousWeight: number = 0;

  openDetails(item: BMIHistoryItem) {
    this.selectedBmi = item;
    this.displayModal = true;
  }

  getLabelClass(value: number): string {
    if (value < 18.5) return 'bg-gray-100 text-gray-700 border-gray-200';
    if (value < 25) return 'bg-[#ECFDF5] text-[#10B981] border-[#d1fae5]'; // Healthy
    if (value < 30) return 'bg-[#FEF2F2] text-[#EF4444] border-[#fee2e2]'; // Overweight
    return 'bg-[#FEF2F2] text-[#EF4444] border-[#fee2e2]'; // Obese
  }

  getLabelText(value: number): string {
    if (value < 18.5) return 'Underweight';
    if (value < 25) return 'Healthy';
    if (value < 30) return 'Overweight';
    return 'Obese';
  }
}

